import { FC, ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import GoogleMapsConfig from '../GoogleMapsConfig/GoogleMapsConfig';
import GoogleTagManagerScreen from '../GoogleTagManagerScreen/GoogleTagManagerScreen';
import PaymentCheckout from '../PaymentCheckout/PaymentCheckout';
import TakerConnect from '../TakerConnect/TakerConnect';
import TakerGo from '../TakerGo/TakerGo';
import ApplePay from '../ApplePay/ApplePay';
import { Integrations } from '~/constants/integrations';
import './style.scss';
import FoodicsScreen from 'src/view/screens/SettingsScreen/screens/Integrations/Integrations/screens/FoodicsScreen/FoodicsScreen';
import T360Screen from 'src/view/screens/SettingsScreen/screens/Integrations/Integrations/screens/T360Screen/T360Screen';

const IntegrationScreen: FC = (): ReactElement | null => {
  const { id } = useParams<{ id: string | undefined }>();
  switch (id) {
    case Integrations.FOODICS:
      return <FoodicsScreen />;
    case Integrations.GOOGLE_TAG_MANAGER:
      return <GoogleTagManagerScreen />;
    case Integrations.TAKER_GO:
      return <TakerGo />;
    case Integrations.GOOGLE_MAPS:
      return <GoogleMapsConfig />;
    case Integrations.CONNECT:
      return <TakerConnect />;
    case Integrations.CHECKOUT:
      return <PaymentCheckout />;
    case Integrations.APPLE_PAY:
      return <ApplePay />;
    case Integrations.T360:
      return <T360Screen />;
    default:
      return null;
  }
};

export default IntegrationScreen;
